import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Shared } from '../shared.service';
import { Tier } from '../tier';
import { Flavor } from '../flavor';
import { Sale } from '../sale';
import { Award } from '../award'
import { Product } from '../product';
import { Ng2ImgToolsService } from 'ng2-img-tools';
import * as firebase from 'firebase';
import * as _ from 'lodash';


@Component({
  selector: 'product-form',
  templateUrl: './product-form.component.html',
  styleUrls: ['./product-form.component.scss']
})

export class ProductFormComponent implements OnInit {

  Object = Object;
  @Input() new_product: Boolean;
  @Input() key;
  @Input() product_copy;
  @Input() active;
  @Input() formType;
  categories;
  cat_list;
  cannabinoids;
  tiers;
  terpenes;
  symptoms;
  arrs = ['cannabinoids', 'tiers', 'terpenes', 'symptoms'];
  cannabinoid_limit = 6;
  tier_limit = 3;
  terpene_limit = 3;
  symptom_limit = 3;
  hasImage: Boolean = false;
  url;
  imageSet = false;
  award_images_reader: FileReader = new FileReader();
  reader: FileReader = new FileReader();
  selectedFile;
  new_product_key;
  active_category;
  colorPicker = false;
  glassPicker = false;
  saving = false;

  storageRef;

  award_image_set = 0;
  award_images = {0:null,1:null,2:null};
  award_image_urls = {0:null,1:null,2:null};
  active_glass_pickers = {0:false,1:false,2:false};

  images: Object = {};
  

  long_species_object = {
      'sativa':"Sativa",
      'h-sativa-dom':"Sativa Dominant",
      'hybrid':"Hybrid",
      'h-indica-dom':"Indica Dominant",
      'indica':"Indica"
  }

  alphabet = 'abcdefghijklmnopqrstuvwxyz';

  @Output() deleteCh: EventEmitter<Object> = new EventEmitter();
  @Output() toggle: EventEmitter<String> = new EventEmitter();

  constructor(public shared: Shared, private imgs: Ng2ImgToolsService) {
      //console.log(shared)
      this.storageRef = firebase.storage().ref();
      this.reader.onloadstart = (event) => {
          console.log(event);
      }
      this.award_images_reader.onloadstart = (event) => {
        console.log(event);
      }

      this.award_images_reader.onload = (event) => {
          console.log(event);
          this.award_image_urls[this.award_image_set] = event.target['result'];
      }

      this.reader.onload = (event) => {
          console.log(event);
          this.url = event.target['result'];
          this.imageSet = true;
          this.hasImage = true;
          //console.log(event);
      }
  }

  ngOnInit() {
      if(this.new_product === true){
        this.key = "new_product";
        this.product_copy = new Product;
        this.product_copy['awards'] = {'a':{'image':"#",'name':''}};
        this.product_copy['descriptors'] = {'a':false};
        this.product_copy['brewer'] = this.shared.settings.name;
        this.product_copy['limit'] = this.shared.settings.limit;
        this.award_image_set = 0;
        this.award_images = {0:null,1:null,2:null};
        this.award_image_urls = {0:null,1:null,2:null};
        this.active_glass_pickers = {0:false,1:false,2:false};
      } else {
          this.key = this.product_copy.$key;
          console.log("KEY: ", this.product_copy.$key, this.product_copy.awards);
          if(this.product_copy['image'] && this.product_copy['image'] != ''){
              this.hasImage = true;
          } else {
              this.hasImage = false;
          }
      }
      if(this.product_copy['a'] === true){
          this.active_category = 'a';
      } else if(this.product_copy['b'] === true){
          this.active_category = 'b';
      } else if(this.product_copy['c'] === true){
          this.active_category = 'c';
      } else {
          this.active_category = 'a';
      }

  }

  ngOnChanges(){
      if(this.product_copy != undefined){
          if(this.product_copy['a'] === true){
              this.active_category = 'a';
          } else if(this.product_copy['b'] === true){
              this.active_category = 'b';
          } else if(this.product_copy['c'] === true){
              this.active_category = 'c';
          } else {
              this.active_category = 'a';
          }
      };

  }

  addProduct(){

      this.product_copy['locations'] = {};
      console.log(this.shared.userLocation.$key);
      this.product_copy.locations[this.shared.userLocation.$key] = true;

      this.shared.productsRef.push(this.product_copy).then((value) => {

          this.new_product_key = value.path.pieces_[value.path.pieces_.length - 1];
          /*
           *  Seriously though, why is it `path.pieces_` instead of `path.pieces?`
           *  Does the terrible bastard that made it that way not understand the
           *  collective hours that developers must have poured into debugging
           *  the fact that they missed an oddly placed underscore? What are 
           *  style guides and standards for if not purely to negate issues
           *  exactly like this one?
           *
           *  Like, fuck, man.
           *
           */

          let images = Object.keys(this.award_images).filter(item => this.award_images[item] != null).map(key => this.award_images[key]);
          console.log(images, this.award_images, this.award_image_set, this.award_image_urls);
          this.saving = true;
          if(images.length > 0){
            let i = -1;
            Promise.all(images.map(image => {
              console.log(image);
              i += 1;
              return this.uploadAward(image, i);
            })).then(snapshots => {
              let j = 0;
              snapshots.forEach(snap => {
                console.log(snap);
                this.product_copy['awards'][this.alphabet[j]]['image'] = snap.downloadURL
                console.log(this.product_copy);
                j += 1;
              });
              if(this.selectedFile){
                this.upload(this.selectedFile).then((snapshot) => {
                  //console.log(snapshot);
                  this.product_copy['image'] = snapshot.metadata.downloadURLs[0];
                  this.hasImage = true;
                  this.shared.productsRef.update(this.new_product_key, this.product_copy);
                }).then(() => {
                  this.saving = false;
                  this.imageSet = false; this.selectedFile = undefined; this.hasImage = false;
                  this.toggle.emit('');
                  this.ngOnInit();
                });
              } else {
                let payload = this.product_copy;
                //console.log(payload, this.active_category);
                this.shared.productsRef.update(this.new_product_key, payload).then(() => {
                  this.saving = false;
                  this.imageSet = false; this.selectedFile = undefined; this.hasImage = false;
                  this.toggle.emit('');
                  this.ngOnInit();
                });
               }
            });
          } else if(this.selectedFile) {
            this.upload(this.selectedFile).then((snapshot) => {
                //console.log(snapshot);
                this.product_copy['image'] = snapshot.metadata.downloadURLs[0];
                this.hasImage = true;
                this.shared.productsRef.update(this.new_product_key, this.product_copy);
            }).then(() => {
                this.saving = false;
                this.imageSet = false; this.selectedFile = undefined; this.hasImage = false;
                this.toggle.emit('');
                this.ngOnInit();
            });
          } else {
            let payload = this.product_copy;
            this.shared.productsRef.update(this.new_product_key, payload).then(() => {
            this.saving = false; this.imageSet = false; this.selectedFile = undefined; this.hasImage = false;
            this.toggle.emit('');
            this.ngOnInit();
            });
          }
      });
  }

  deleteNewProduct(){
      this.product_copy = new Product;
      this.toggle.emit('');
  }

  pop(arrName){
      let len = Object.keys(this.product_copy[arrName]).length-1;
      delete this.product_copy[arrName][this.alphabet[len]];
      if(arrName === 'awards'){
        this.award_images[len] = null;
        this.award_image_set[len] = false;
        this.award_image_urls[len] = null;
      }
      //console.log(this.product_copy[arrName]);
  }

  add(arrName){
      let new_thing;
      let len = Object.keys(this.product_copy[arrName]).length;
      let letter = this.alphabet[len];
      switch(arrName){
          case 'tiers':
            new_thing = new Tier;
            break;
          case 'awards':
            new_thing = new Award;
            break;
          default:
            new_thing = new Flavor;
            break;
      }
      this.product_copy[arrName][letter] = new_thing;
  }

  hasAwardImage(image){
    if(image === '' || image === '#' || !image){
      return false;
    }
    return true;
  }

  save(){
      let key;
      this.new_product ? key = this.new_product_key : key = this.key;
      let images = Object.keys(this.award_images).filter(item => this.award_images[item] != null).map(key => this.award_images[key]);
      console.log(images, this.award_images, this.award_image_set, this.award_image_urls);
      this.saving = true;
      if(images.length > 0){
        let i = -1;
        Promise.all(images.map(image => {
          console.log(image);
          i += 1;
          return this.uploadAward(image, i);
        })).then(snapshots => {
          let j = 0;
          snapshots.forEach(snap => {
            console.log(snap);
            this.product_copy['awards'][this.alphabet[j]]['image'] = snap.downloadURL
            console.log(this.product_copy);
            j += 1;
          });
          if(this.selectedFile){
            this.upload(this.selectedFile).then((snapshot) => {
              //console.log(snapshot);
              this.product_copy['image'] = snapshot.metadata.downloadURLs[0];
              this.hasImage = true;
              delete this.product_copy['$key'];
              this.shared.productsRef.update(key, this.product_copy);
            }).then(() => {
              this.saving = false;
              this.ngOnInit();
            });
          } else {
            let payload = this.product_copy;
            delete payload['$key'];
            //console.log(payload, this.active_category);
            this.shared.productsRef.update(key, payload).then(() => {
              this.saving = false;
              this.ngOnInit();
            });
           }
        });
      } else if(this.selectedFile) {
        this.upload(this.selectedFile).then((snapshot) => {
            //console.log(snapshot);
            this.product_copy['image'] = snapshot.metadata.downloadURLs[0];
            this.hasImage = true;
            delete this.product_copy['$key'];
            this.shared.productsRef.update(key, this.product_copy);
        }).then(() => {
            this.saving = false;
            this.ngOnInit();
        });
      } else {
        let payload = this.product_copy;
        delete payload['$key'];
        //console.log(payload, this.active_category);
        this.shared.productsRef.update(key, payload).then(() => {
            this.saving = false;
            this.ngOnInit();
        });
      }
  }

  log(meh){
      //console.log(meh);
  }

  deleteChanges(){
      this.deleteCh.emit(this.product_copy);
  }

  deleteProduct(){
      this.shared.productsRef.remove(this.key);
  }
  stagePhoto(event){
    this.selectedFile = event.target.files[0];
    console.log(event);
    this.imgs.compress([this.selectedFile], .5).subscribe(img => {
      this.reader.readAsDataURL(img);
      this.selectedFile = img;
    });
  }

  stageAwardPhoto(event, index){
      let file = event.target.files[0];
      this.imgs.compress([file], .5).subscribe(img => {
        this.award_image_set = index;
        this.award_images_reader.readAsDataURL(img);
        this.award_images[index] = img;
      })
  }

  upload(file) {
        // Create a root reference
        let selectedFile = file;
        let key;
        this.new_product ? key = this.new_product_key : key = this.key;
        //console.log(key);
        return this.storageRef.child(`/images/${key}`).put(selectedFile);
    }

  uploadAward(file, index){
    let key;
    this.new_product ? key = this.new_product_key : key = this.key;
    return this.storageRef.child(`/images/${key}_${index}`).put(file);
  }

  removeFromMenu(){
      let payload = {locations: {...this.product_copy.locations}};
      payload.locations[this.shared.firebase_user.location] = false;
      //console.log(payload);
      this.shared.productsRef.update(this.key, payload);
      //console.log(this.product_copy);
  }

  toggleColorPicker(){
    this.colorPicker = !this.colorPicker;
  }

  toggleGlassPicker(index, tier){
    console.log(index, tier.$key);
    this.active_glass_pickers[index] = ! this.active_glass_pickers[index];
    console.log(this.active_glass_pickers, index);
  }




}



// WEBPACK FOOTER //
// ./src/app/product-form/product-form.component.ts